import { render, staticRenderFns } from "./FeeManage.vue?vue&type=template&id=2d1771de&scoped=true&"
import script from "./FeeManage.vue?vue&type=script&lang=js&"
export * from "./FeeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1771de",
  null
  
)

export default component.exports